








import {Component, Prop, Vue} from 'vue-property-decorator';

  @Component({
    inheritAttrs: false,
  })
  export default class StBadge extends Vue {
    @Prop() large!: boolean;
    @Prop({default: 'text-white bg-green-500'}) bgClass!: string;
  }
